import { render, staticRenderFns } from "./_PorterageField.vue?vue&type=template&id=0a635313"
import script from "./_PorterageField.vue?vue&type=script&lang=js"
export * from "./_PorterageField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports